<template>
  <div>
    <!-- <app-breadcrumb
      :page-title="$t('tasks')"
      :directory="$t('tasks')"
      :icon="'sidebar'"
    /> -->
    <div class="card card-with-shadow border-0">
      <div class="card-header p-primary bg-transparent">
        <h5 class="card-title m-0">{{ title }}</h5>
      </div>
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <el-form v-if="active === 1">
          <form
            ref="form"
            data-url="/form/validate-fields"
            class="mb-sm-0"
            :class="{ 'loading-opacity': preloader }">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("title") }}</label>
                    <app-input type="text" v-model="inputs.title" />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="form-group">
                    <label>{{ $t("description") }}</label>
                    <app-input
                      type="textarea"
                      id="textarea-id"
                      :label="$t('message_placeholder')"
                      v-model="inputs.description"
                    />
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("users") }}</label>
                  <app-input
                    type="multi-select"
                    :placeholder="$t('select_user')"
                    :list="this.users"
                    :required="true"
                    v-model="inputs.select_users"
                  />
                  <p class="font-italic text-muted">
                    {{ $t("shortcut_user_create") }} <span><a href="#" @click.prevent="addUser()">{{$t("add_user")}}</a></span>
                  </p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("task_category") }}</label>
                  <app-input
                    type="search-select"
                    :placeholder="$t('select_task_category')"
                    :list="this.taskCategories"
                    :required="true"
                    v-model="inputs.select_task_category"
                  />
                  <p v-if="categoryAddShow == false" class="font-italic text-muted">
                    {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
                  </p>
                </div>
                <div v-if="categoryAddShow == true">
                  <div class="d-flex align-items-center">
                    <app-input
                      class="mr-2 flex-grow-1"
                      type="text"
                      placeholder="Enter Category Name"
                      v-model="category_name"/>
                    <button type="submit"
                      class="btn btn-sm btn-primary mr-2"
                      @click.prevent="createCategory()">
                      {{ $t('save') }}
                    </button>
                    <a href="#" class="text-muted" @click.prevent="closeCategory()">
                        <app-icon name="x"/>
                    </a>
                  </div>
                  <small class="text-danger ml-2" v-html="message"></small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("customer") }}</label>
                  <app-input
                    type="search-select"
                    :placeholder="$t('select_customer')"
                    :list="this.customers"
                    v-model="inputs.select_customer"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="inputs_forms">{{ $t("forms") }}</label>
                  <app-input
                    type="multi-select"
                    :isAnimatedDropdown="true"
                    :placeholder="$t('forms')"
                    :list="forms"
                    v-model="inputs.form_id"
                  />
                  <p v-if="refreshShow == false" class="font-italic text-muted">
                    {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
                  </p>
                  <p v-if="refreshShow == true" class="font-italic text-muted">
                    <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>                  
                  </p>
                </div>
              </div>
            </div>
<!--            Form Preview-->
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12"/>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <p v-if="inputs.form_id && inputs.form_id.length>0">Click to preview selected forms:</p>
                <div v-for="(form_id) in inputs.form_id" >
                  <a :href="'/form/preview/'+form_id"  target="_blank">{{formName(form_id)}}</a>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("start_date") }}</label>
                  <app-input
                    type="date"
                    :required="true"
                    v-model="inputs.start_date"
                    :placeholder="$t('select_valid_date')"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("start_time") }}</label>
                  <app-input
                    type="time"
                    :required="true"
                    v-model="inputs.start_time"
                    :placeholder="$t('select_valid_time')"
                    :min-time="new Date().getTime().toString()"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("due_date") }}</label>
                  <app-input
                    type="date"
                    :required="true"
                    v-model="inputs.due_date"
                    :placeholder="$t('select_valid_date')"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("end_time") }}</label>
                  <app-input
                    type="time"
                    :required="true"
                    v-model="inputs.end_time"
                    :placeholder="$t('select_valid_time')"
                    :min-time="new Date().getTime().toString()"
                  />
                </div>
              </div>
            </div>



            <div class="row" v-if="total_recuring_task > 0">
              <div class="col-lg col-md-12 col-sm-12">
                <div class="form-group">
                  <label class="text-success">This task has <b>{{ total_recuring_task }}</b> Repeated task</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("priority") }}</label>
                  <app-input
                    type="radio"
                    :required="true"
                    :list="list"
                    v-model="inputs.priority"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <app-input
                    type="dropzone"
                    :required="true"
                    v-model="inputs.dropzone_files"
                  />
                  <small class="text-muted font-italic">
                    {{ $t("recommended_dropzone_file_validation") }}
                  </small>
                </div>
              </div>
            </div>
            <div class="mt-5 action-buttons">
              <button
                type="submit"
                class="btn btn-primary mr-2"
                @click.prevent="submitData"
              >
                {{ $t("submit") }}
              </button>
              <button
                type="submit"
                class="btn btn-secondary"
                @click.prevent="clear"
              >
                {{ $t("clear") }}
              </button>
            </div>
          </form>
        </el-form>
        <el-form v-if="active === 2">
          <shortcut-user-create :back="backTaskCreate"></shortcut-user-create>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import AppLibrary from "../../../../Helpers/AppLibrary";
import {
  GET_COMPANY_USERS,
  CUSTOMERS_LIST,
  GET_TASK_CATEGORIES,
  TASK_SHOW,
  TASK_UPDATE,
  BUYER_CERTIFICATE_FORMS,TASK_CATEGORY_STORE,
} from "../../../../Config/ApiUrl";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";

export default {
  name: "TaskEdit",
  extends: AppLibrary,
  mixins: [FormMixin],
  data() {
    return {
      refreshShow: false,
      cat: {},
      message: '',
      categoryAddShow: false,
      category_name: '',
      title: this.$t("update_tasks"),
      active: 1,
      forms: [],
      checked_task_dependent: false,
      checked_repeat: false,
      preloader: false,
      total_recuring_task: false,
      inputs: {
        priority: "High",
      },
      list: [
        {
          id: "High",
          value: "High",
        },
        {
          id: "Medium",
          value: "Medium",
        },
        {
          id: "Low",
          value: "Low",
        },
      ],
      duraton: [
        { id: "", value: "Choose One" },
        { id: "Day", value: "Day" },
        { id: "Week", value: "Weeks" },
        { id: "Month", value: "Month" },
        { id: "Year", value: "Year" },
      ],
      users: [],
      taskCategories: [],
      customers: [],
    };
  },
  methods: {
    formName(formId){
      let formObj = {};
      for (let i = 0; i < this.forms.length; i++) {
        if (this.forms[i].id === formId) {
          formObj = this.forms[i];
        }
      }
      if(formObj){
        return formObj.value;
      }
    },
    addCategory() {
      this.categoryAddShow = true;
    },
    closeCategory() {
      this.categoryAddShow = false;
    },
    createCategory() {
      if (this.category_name == '') {
          this.message = 'Category name is required';
      }
      else {
        this.cat.category_name = this.category_name;
        axiosPost(TASK_CATEGORY_STORE, this.cat)
          .then((res) => {
            this.categoryAddShow = false;
            this.$toastr.s(res.data.message);
            this.getTaskCategories();
            this.category_name = '';
          })
          .catch((error) => {
            
          });
      }
    },
    addUser() {
      this.title = this.$t("add_user");
      this.active = 2;
    },
    backTaskCreate(value) {
      this.getUsers();
      this.active = value;
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submitData() {
      if (this.inputs.date)
        this.inputs.date = this.getDateFormatForBackend(this.inputs.date);
      if (this.inputs.start_date)
        this.inputs.start_date = this.getDateFormatForBackend(
          this.inputs.start_date
        );
      if (this.inputs.due_date)
        this.inputs.due_date = this.getDateFormatForBackend(
          this.inputs.due_date
        );
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // this.inputs.task_id = split[6];
      let id = this.$attrs['props'].id;
      this.inputs.task_id = id;
      axiosPost(TASK_UPDATE, this.inputs)
        .then((res) => {
          
          // window.location = "/admin/tasks";
          this.$toastr.s(res.data.message);
          this.$attrs['props'].fun(1);
        })
        .catch((error) => {
          
        });
      // this.save(this.inputs);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {};
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    getUsers() {
      axiosGet(GET_COMPANY_USERS)
        .then((res) => {
          this.users = res.data;
        })
        .catch((error) => {
          
        });
    },
    getTaskCategories() {
      axiosGet(GET_TASK_CATEGORIES)
        .then((res) => {
          this.taskCategories = res.data;
        })
        .catch((error) => {
          
        });
    },
    getTask(id) {
      axiosGet(TASK_SHOW + "/" + id)
        .then((res) => {
          this.inputs = res.data;
          this.total_recuring_task = res.data.total_recuring_task;
          // console.log(res.data);
        })
        .catch((error) => {
          
        });
    },
    getCustomers() {
      axiosGet(CUSTOMERS_LIST)
        .then((response) => {
          
          this.customers = response.data;
        })
        .catch((error) => {
          
        });
    },
    getForms() {
      axiosGet(BUYER_CERTIFICATE_FORMS)
        .then((res) => {
          this.forms = res.data;
        })
        .catch((error) => {
          
        });
    },
    refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/mydocument', '_blank');
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    this.getUsers();
    this.getTaskCategories();
    this.getCustomers();
    // this.getTask(split["6"]);
    let id = this.$attrs['props'].id;
    this.getTask(id);
    this.getForms();
  },
};
</script>
